import TdSummaryPerDate from "./TdSummaryPerDate";
import type * as type from "@vTypes";
import { cn } from "@utils/cn.ts";
function TfootSummary({
  shift,
  trClass,
  enums,
  itemValue,
  violations,
  groupLength,
  groupIndex,
  groupDefaultShift,
}: {
  shift: type.availableShifts;
  currentShiftId?: string;
  enums?: string;
  trClass: string | null;
  itemValue: number[];
  violations?: any[];
  groupLength: number;
  groupIndex: number;
  groupDefaultShift?: string | null;
}) {
  const targetShift = groupDefaultShift || shift?.default_shift;

  // 에러가 있는 날짜들 찾기
  const errorDays = new Set(
    violations
      ?.filter(
        (v) =>
          (v.type === "manpower_shortage" || v.type === "manpower_excess") &&
          v.shift === targetShift
      )
      .map((v) => v.day) || []
  );

  return (
    <div
      className={cn(
        "rt_tfoot_tr flex items-center!",

        trClass,
        !(enums === "view") && "max-h-[40px]",
        enums === "view" && "!h-[35px] max-h-[35px]"
      )}
    >
      <div className={cn("flex")}>
        {/* 전월 말일 데이터 길이만큼 공간을 띄워서 캘린더 일별 헤더와 수직 정렬을 맞춥니다 */}

        {itemValue.map((count, index) => {
          // const isError = violations?.some(
          //   (v) =>
          //     v.type === "manpower_shortage" &&
          //     v.day === index &&
          //     v.shift === shift?.default_shift
          // );

          const isError = errorDays.has(index);

          return (
            <TdSummaryPerDate
              key={index}
              count={count}
              day={index + 1}
              isError={isError}
              groupLength={isError ? groupLength : undefined}
              groupIndex={groupIndex}
            />
          );
        })}
      </div>
    </div>
  );
}
export default TfootSummary;
